import {ReactNode} from "react";
import AppBreadCrumb from "@/component/common/breadcrumb/AppBreadCrumb.tsx";
import {Flex} from "antd";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";

const ManageContentLayout = (
    {
        headerFunction,
        hasBreadcrumb = true,
        children
    }: {
        headerFunction?: ReactNode,
        hasBreadcrumb?: boolean,
        children?: ReactNode
    }) => {
    const {t} = useTranslation();
    const location = useLocation();

    return (
        <>
            <div className={'mb-3'}>
                <Flex justify={'flex-start'} align={'end'}>
                    <div className={'flex-1'}>
                        <h2>
                            {t(`breadcrumb.${location.pathname.substring(location.pathname.lastIndexOf('/') + 1)}`)}
                        </h2>
                        {hasBreadcrumb && <AppBreadCrumb/>}
                    </div>
                    {headerFunction}
                </Flex>
            </div>
            <div className={'relative grow'}>
                {children}
            </div>
        </>
    )
}

export default ManageContentLayout;